import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ProFunnelModel } from "../../../../model/builk/profunnel/profunnel.model";
import { ProFunnelService } from "../../../../service/api/builk/profunnel.service";
import { ISubscription } from "rxjs/Subscription";
import { BadgeModel } from "../../../../model/builk/profunnel/profunnel-badge.model";
import { BadgeListModel } from "../../../../model/builk/profunnel/profunnel-badge-list.model";

@Component({
  selector: "bo-builk-profunnel-badge",
  templateUrl: "./profunnel-badge.component.html",
  styleUrls: ["./profunnel-badge.component.scss"]
})
export class ProFunnelBadgeComponent implements OnInit, OnDestroy {

  @Input() rowData: ProFunnelModel;
  @ViewChild("template") template: TemplateRef<any>;

  constructor(
    private modalService: BsModalService,
    public router: Router,
    private proFunnelService: ProFunnelService
  ) { }

  modalRef: BsModalRef;
  subscription: ISubscription;
  badgeProFunnel: Array<BadgeModel>;
  companySurrKey: number;
  selectedBadgeList = new Array<number>();
  badgeList: BadgeListModel = new BadgeListModel();
  hideCompany: boolean;
  proFunnelDataModel: ProFunnelModel;

  ngOnInit(): void {
  }

  openModal(id: number): void {
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-sm"
    });
    this.companySurrKey = id;
    this.loadBadge();
    this.getBadgeDetail(id);
  }

  openModalByModel(data: ProFunnelModel) {
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-sm"
    });
    this.companySurrKey = data.id;
    this.hideCompany = data.companyIsObsolete;
    this.proFunnelDataModel = data;
    this.loadBadge();
    this.getBadgeDetail(data.id);
  }

  loadBadge(): void {
    this.subscription = this.proFunnelService.getListBadgeBackOffice()
      .subscribe(
        response => {
          this.badgeProFunnel = response;
        }
      );
  }

  getBadgeDetail(companySurrKey: number): void {
    this.subscription = this.proFunnelService.getBadgeByIdBackOffice(companySurrKey)
      .subscribe(
        response => {
          this.selectedBadgeList = response;
        }
      );
  }

  loadCompanyDetail(companysurrkey: number): void {
    // throw new Error("Method not implemented.");
    this.subscription = this.proFunnelService.getCompanyDetailByCompanySurrkey(companysurrkey).subscribe(
      respnse => { }
    );
  }

  setBadge(item, event): void {
    const idx = this.selectedBadgeList.indexOf(item);
    if (item === 0 && event === 0) {
      this.selectedBadgeList = [];
    } else if (!event.target.checked) {
      this.selectedBadgeList.splice(idx, 1);
      const value0 = this.selectedBadgeList.indexOf(0);
      if (value0 > -1) {
        this.selectedBadgeList.splice(value0, 1);
      }
    } else {
      this.selectedBadgeList.push(item);
      const value0 = this.selectedBadgeList.indexOf(0);
      if (value0 > -1) {
        this.selectedBadgeList.splice(value0, 1);
      }
    }
    this.selectedBadgeList.sort((n1, n2) => n1 - n2);
  }

  setHideCompany(event): void {
    console.log(event.target.checked);
    this.hideCompany = event.target.checked;
  }

  updateBadge(): void {
    //Check Update HideCompany
    if (this.proFunnelDataModel.companyIsObsolete != this.hideCompany) {
      this.subscription = this.proFunnelService.updateHideCompanyBackOffice(this.companySurrKey, this.hideCompany)
        .subscribe(
          response => { });
    }
    this.badgeList.companySurrKey = this.companySurrKey;
    this.badgeList.badgeList = this.selectedBadgeList;
    this.subscription = this.proFunnelService.updateBadgeBackOffice(this.badgeList)
      .subscribe(
        response => {
          if (response) {
            this.modalRef.hide();
          }
        }
      );

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
